import React from 'react';

interface EqxTaskStatusBadgeProps {
    status: string;
    responsive?: boolean;
    running?: boolean;
}

const EqxTaskStatusBadge: React.FC<EqxTaskStatusBadgeProps> = ({ status, responsive, running }) => {
    let colour = 'secondary';
    let icon = 'fas fa-question-circle';
    let extraContent = null;
    let text = status;

    if (status === 'Finished') {
        colour = 'success';
        icon = 'fas fa-check';
    } else if (status === 'Started') {
        colour = 'warning';
        icon = 'fas fa-check';
        extraContent = running !== undefined && (
            <>
                {' '}
                {running ? (
                    <span className="badge bg-success blink" title="Running">
                        <span className="fas fa-power-off fa-spin"></span>
                        <span className={responsive ? ' d-none d-md-inline' : ''}> Running</span>
                    </span>
                ) : (
                    <span className="badge bg-warning" title="Paused">
                        <span className="fas fa-pause"></span>
                        <span className={responsive ? ' d-none d-md-inline' : ''}> Paused</span>
                    </span>
                )}
            </>
        );
    } else if (status === 'Scheduled') {
        colour = 'warning';
        icon = 'fas fa-clock';
    } else if (status === 'Not Scheduled') {
        colour = 'secondary';
        icon = 'fas fa-clock';
        text = 'Unscheduled';
    } else if (status === 'Pending Approval') {
        colour = 'info';
        icon = 'fas fa-question-circle';
    } else if (status === 'Pending Acceptance') {
        colour = 'primary';
        icon = 'fas fa-question-circle';
    } else if ([
        'Rejected',
        'Voided',
        'Cancelled',
        'Aborted',
    ].includes(status)) {
        colour = 'danger';
        icon = 'fas fa-times';
    }

    return (
        <>
            <span className={'badge bg-' + colour} title={text}>
                <span className={icon}></span>
                <span className={responsive ? ' d-none d-md-inline' : ''}> {text}</span>
            </span>
            {extraContent}
        </>
    );
};

export default EqxTaskStatusBadge; 